<div class="content-wrapper">
  <div class="page-heading d-flex align-items-center gap-3">
    <button class="btn btn-primary" (click)="goBack()">
      <i class="fa-solid fa-arrow-left" data-bs-toggle="Tooltip" title="Go Back"></i>
    </button>
  </div>
  <div class="card">
    <div class="card-header">
      <h2 class="table-ttl">Edit Any Content</h2>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table  table-striped table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Version</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let rule of rules">
              <!-- Top-level section rule -->
              <tr class="table-primary">
                <td>{{ rule.id }}</td>
                <td>{{ rule.title }}</td>
                <td>{{ rule.version }}</td>
                <td>
                  {{ rule.content }}
                  <!-- <u>v{{ rule.version }}</u> -->
                </td>
                <td>
                  <button class="btn btn-primary btn-sm" (click)="abandonRule(rule.id)">
                    Edit
                  </button>
                </td>
              </tr>

              <!-- Recursively load subrules -->
              <ng-container *ngTemplateOutlet="
                  recursiveSubrules;
                  context: { $implicit: rule.subContents, level: 1 }
                "></ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="!rules.length">
    <app-loader></app-loader>
  </div>
</div>
<!-- Recursive Template -->
<ng-template #recursiveSubrules let-subrules let-level="level">
  <ng-container *ngFor="let sub of subrules">
    <tr>
      <td [style.padding-left.px]="level * 20">↳ {{ sub.id }}</td>
      <td>{{ sub.title }}</td>
      <td>{{ sub.version }}</td>
      <td>
        {{ sub.content }}
        <!-- <sup>&nbsp;<b>v{{ sub.version }}</b></sup> -->
      </td>
      <td>
        <button class="btn btn-primary btn-sm" (click)="abandonRule(sub.id)">
          Edit
        </button>
      </td>
    </tr>

    <!-- Recurse if more nested subrules exist -->
    <ng-container *ngIf="sub.subContents">
      <ng-container *ngTemplateOutlet="
          recursiveSubrules;
          context: { $implicit: sub.subContents, level: level + 1 }
        "></ng-container>
    </ng-container>
  </ng-container>
</ng-template>